<template>
    <Card>
        <div class="card-body">
            <div class="ph-status-tabs mr-2">
                <button type="button" :class="['ph-status-tab', filters.is_paid === null ? 'active' : '']" @click="selectFilter(null)">{{ $t('paymentTable.paymentHistory.filterAll') }}</button>
                <button type="button" :class="['ph-status-tab', filters.is_paid === true ? 'active' : '']" @click="selectFilter(true)">{{ $t('paymentTable.paymentHistory.filterPaid') }}</button>
                <button type="button" :class="['ph-status-tab', filters.is_paid === false ? 'active' : '']" @click="selectFilter(false)">{{ $t('paymentTable.paymentHistory.filterPending') }}</button>
            </div>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="url"
            :columns="columns"
            v-model:orders="orders"
        >
            <template #td-created_at="{row}">
                <div class="font-weight-semibold">{{ DateFormatter.formatDate(row.created_at) }}</div>
                <div class="font-size-xs text-muted">{{ DateFormatter.formatTime(row.created_at) }}</div>
            </template>
            <template #td-appointment="{row}">
                <div class="font-weight-semibold">{{ row.tariff ? row.tariff.name : $t('paymentTable.paymentHistory.aiTopUp') }}</div>
                <div class="font-size-xs text-muted">ID #{{ row.id }}</div>
            </template>
            <template #td-invoice="{row}">
                <AppNullableCell>
                    <template #default v-if="row.external_id">
                        <code class="ph-invoice" :title="row.external_id">{{ row.external_id }}</code>
                    </template>
                </AppNullableCell>
            </template>
            <template #td-sum="{row}">
                {{ Price.factory(row.sum).toCurrencyString('UAH') }}
            </template>
            <template #td-status="{row}">
                <span :class="['ph-status', getStatusClass(row.is_paid)]">
                    <span class="ph-status-dot"></span>{{ row.is_paid ? $t('labels.paid') : $t('labels.pending') }}
                </span>
                <div class="font-size-xs text-danger mt-1" :title="row.external_exception" v-if="row.external_exception">
                    <i class="icon-warning22 mr-1"></i>{{ row.external_exception }}
                </div>
            </template>
            <template #td-action="{row}">
                <AppButton color="indigo" v-if="!row.is_paid" @click="pay(row.external_url)" :disabled="!row.external_url">
                    {{ $t('paymentTable.actions.pay') }}
                </AppButton>
                <AppButton color="light" v-else disabled>
                    <i class="icon-file-pdf mr-2"></i>
                    {{ $t('paymentTable.actions.receipt') }}
                </AppButton>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../components/new/table/tableHandle';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import AppNullableCell from '../../../../components/tables/AppNullableCell.vue';

import DateFormatter from '../../../../../services/DateFormatter';
import Price from '../../../../../services/Price/Price';

export default {
    name: "PaymentHistoryCard",
    components: {
        Card, FetchTable, AppButton, AppNullableCell
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            Price,
            DateFormatter,
            url: `/projects/${this.$route.params.projectUuid}/core/payments`,
            columns: [
                { key: 'created_at', name: this.$t('table.titles.date'), width: '80px', type: 'string', order: true },
                { key: 'appointment', name: this.$t('table.titles.appointment'), width: '200px', type: 'string', order: false },
                { key: 'invoice', name: this.$t('table.titles.invoice'), width: '120px', type: 'string', order: false },
                { key: 'sum', name: this.$t('table.titles.sum'), width: '120px', type: 'string', order: true },
                { key: 'status', name: this.$t('table.titles.status'), width: '120px', type: 'string', order: true },
                { key: 'action', name: this.$t('table.titles.action'), width: '120px', type: 'number', order: false },
            ],
            orders: [
                {
                    column: 'created_at',
                    dir: 'desc'
                }
            ],
            filters: {
                is_paid: null
            }
        }
    },
    methods: {
        getStatusClass(is_paid) {
            return is_paid ? 'st-paid' : 'st-pending';
        },
        pay(externalUrl) {
            window.open(externalUrl, '_blank', 'noopener,noreferrer');
        },
        fetchPayments() {
            let params = {};

            if (this.filters.is_paid !== null) {
                params.is_paid = Number(this.filters.is_paid);
            }

            this.tableHandle.fetchRows(params);
        },
        selectFilter(is_paid) {
            this.filters.is_paid = is_paid;
            this.fetchPayments();
        },
    },
    mounted() {
        this.tableHandle.fetchRows();
    }
}
</script>
<style scoped>
.ph-status-tabs {
    display: flex;
    gap: 2px;
    background: #ECEFF1;
    padding: 3px;
    border-radius: 5px;
    width: fit-content;
}
.ph-status-tab.active {
    background: #fff;
    color: #3F51B5;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .08);
}
.ph-status-tab {
    appearance: none;
    border: 0;
    background: transparent;
    padding: 4px 12px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 500;
    color: #555;
    cursor: pointer;
    transition: all .15s ease-in-out;
    white-space: nowrap;
}
.ph-invoice {
    background: #F5F5F7;
    border: 1px solid #ECEFF1;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    color: #555;
    font-family: "Roboto Mono", "SF Mono", Menlo, Consolas, monospace;
}
.ph-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .02em;
}
.ph-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
}
.ph-status.st-pending {
    background: #E3F2FD;
    color: #1565C0;
}
.ph-status.st-paid {
    background: #E8F5E9;
    color: #2E7D32;
}
.ph-status.st-pending .ph-status-dot {
    background: #2196F3;
    animation: pulse 1.5s ease-in-out infinite;
}
.ph-status.st-paid .ph-status-dot {
    background: #4CAF50;
}
</style>